var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPersonCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.75,7.5c0,2.0711 -1.6789,3.75 -3.75,3.75c-2.07107,0 -3.75,-1.6789 -3.75,-3.75c0,-2.07107 1.67893,-3.75 3.75,-3.75c2.0711,0 3.75,1.67893 3.75,3.75z",
    fill: "inherit",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m0,10c0,-5.52285 4.47715,-10 10,-10c5.5228,0 10,4.47715 10,10c0,5.5228 -4.4772,10 -10,10c-5.52285,0 -10,-4.4772 -10,-10zm10,-8.75c-4.83249,0 -8.75,3.91751 -8.75,8.75c0,2.0668 0.71657,3.9662 1.91483,5.4634c0.88883,-1.4318 2.84097,-2.9634 6.83517,-2.9634c3.9942,0 5.9463,1.5316 6.8352,2.9634c1.1982,-1.4972 1.9148,-3.3966 1.9148,-5.4634c0,-4.83249 -3.9175,-8.75 -8.75,-8.75z",
    fill: "inherit",
    id: "svg_2",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPersonCircle);
export default __webpack_public_path__ + "static/media/ico-person-circle.5b1f5ec3dec194bbc23b7ae4570ef84c.svg";
export { ForwardRef as ReactComponent };